import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Message } from 'primereact/message';
import apiFetch from '../../auth/apiFetch';
import { properties } from '../../properties';

export function AffiliatePicker({ visible, onHide, onSelect }) {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    async function search() {
        const q = query.trim();
        if (!q) return;
        setLoading(true);
        setError('');
        setResults([]);
        try {
            const res = await apiFetch(
                `${properties.baseURL}${properties.affiliatesByNamePath}/${encodeURIComponent(q)}`
            );
            if (!res.ok) throw new Error(`Erro ${res.status} ao buscar filiados`);
            const data = await res.json();
            setResults(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }

    function handleHide() {
        setQuery('');
        setResults([]);
        setError('');
        onHide();
    }

    function handleSelect(affiliate) {
        onSelect(affiliate);
        handleHide();
    }

    const actionBody = (row) => (
        <Button
            label="Selecionar"
            className="p-button-sm p-button-outlined"
            onClick={() => handleSelect(row)}
        />
    );

    return (
        <Dialog
            header="Buscar filiado"
            visible={visible}
            style={{ width: '52vw' }}
            onHide={handleHide}
            modal
        >
            <div className="flex gap-2 mb-3">
                <InputText
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    onKeyPress={e => e.key === 'Enter' && search()}
                    placeholder="Nome do filiado"
                    className="flex-1"
                    autoFocus
                />
                <Button label="Buscar" icon="pi pi-search" onClick={search} loading={loading} />
            </div>
            {error && (
                <Message severity="error" text={error} className="w-full mb-3" style={{ justifyContent: 'flex-start' }} />
            )}
            <DataTable
                value={results}
                emptyMessage="Nenhum resultado. Digite um nome e clique em Buscar."
                responsiveLayout="scroll"
            >
                <Column field="jkaId" header="FL" style={{ width: '8rem' }} />
                <Column field="name" header="Nome" />
                <Column body={actionBody} style={{ width: '8rem' }} />
            </DataTable>
        </Dialog>
    );
}
